import React, { useContext } from 'react';
import Model from './models/Model';
import useI18n from '../../hooks/useI18n';
import { UserContext } from '@/context/UserContext';
import InvoicePreview from './InvoicePreview';

interface BillingModalProps {
  isModalOpen: boolean;
  handleModal: () => void;
  invoiceUrl: string;
}

const BillingModal: React.FC<BillingModalProps> = ({
  isModalOpen,
  handleModal,
  invoiceUrl,
}) => {
  const { t } = useI18n();

  const userContext = useContext(UserContext);
  if (!userContext) {
    throw new Error('useContext must be used within a UserProvider');
  }
  const { user } = userContext;

  const handleClose = () => {
    handleModal();
  };

  return (
    <Model isOpen={isModalOpen} onClose={handleClose}>
      <div className="w-[594px]">
        <div className="flex justify-between ">
          <div className="flex gap-4 items-center">
            <img
              src="../assets/uploadBlueIcon.svg"
              className="border-2 border-[#E5E9EB] h-[48px] w-[48px] rounded-full"
            />
            <div>
              <div className="text-[#121111] font-medium text-lg">
                {user?.brand.name}
              </div>
              <div className="text-[#B3B3B2] text-base font-normal">
                {t('common.submittedInvoice')}
              </div>
            </div>
          </div>
          <img
            src="/assets/fi_close_black.svg"
            className=" h-[24px] w-[24px] cursor-pointer"
            onClick={handleClose}
          />
        </div>
        <div className="border border-[#B3B3B2] my-4"></div>
        <div className="flex justify-center">
          <div className="max-h-[600px] overflow-y-auto border rounded-lg p-2">
            <InvoicePreview
              src={invoiceUrl}
              alt={t('common.submittedInvoice')}
              className="w-full object-contain"
            />
          </div>
        </div>
      </div>
    </Model>
  );
};

export default BillingModal;
